import { graphql, StaticQuery } from 'gatsby';
import React from 'react';

import PriceCard from './priceCard/PriceCard';
import Cross from '../../assets/icons/cross.svg';

import { useModal } from '../../context/ModalContext';

import './ConsultPrices.scss';

export default function ConsultPrices() {
  const { closeModal } = useModal();

  return (
    <StaticQuery
      query={graphql`
        query {
          directus {
            consult_prices {
              title
              price
            }
          }
        }
      `}
      render={(data) => (
        <div className="consult-prices">
          <Cross
            className="close"
            width="28px"
            height="28px"
            onClick={() => closeModal()}
          />
          <h3>
            Our
            <span className="hide-title">&nbsp;self-pay</span>
            <span className="salmon">&nbsp;prices</span>
          </h3>
          <div className="cards-container">
            {data.directus.consult_prices
              .map((priceCard) => (
                <PriceCard
                  key={`price-card_${priceCard.title}`}
                  title={priceCard.title}
                  price={priceCard.price}
                />
              ))}
          </div>
        </div>
      )}
    />
  );
}
